export async function hashApiKey(apiKey) {
    const data = new TextEncoder().encode(apiKey);
    const digest = await crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
}
